import { render, staticRenderFns } from "./BrandEditionModal.vue?vue&type=template&id=1dcd2f4a&scoped=true"
import script from "./BrandEditionModal.vue?vue&type=script&lang=js"
export * from "./BrandEditionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd2f4a",
  null
  
)

export default component.exports